<template>
  <div class="scene">
    <button class="mybtn" @click="startSence">transition</button>
    <transition-group name="fade">
      <div v-show="show" class="img img1" :key="1" ref="img1"></div>
      <div v-show="show" class="img img2" :key="2" ref="img2"></div>
      <div v-show="show" class="img img3" :key="3" ref="img3"></div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'Scene2',
  data () {
    return {
      show: false
    }
  },
  mounted () {
    setTimeout(this.startSence, 10000)
    setTimeout(this.hideImg1, 14000)
    setTimeout(this.hideImg2, 14000)
    setTimeout(this.hideImg3, 18000)
  },
  methods: {
    startSence () {
      this.show = !this.show
    },
    hideImg1 () {
      this.$refs.img1.className = 'img img1 fade-leave-active fade'
    },
    hideImg2 () {
      this.$refs.img2.className = 'img img2 fade-leave-active fade'
    },
    hideImg3 () {
      this.$refs.img3.className = 'img img3 fade-leave-active fade'
    }
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .mybtn
    position absolute
    top 0
    left 50%
    z-index 99
    visibility hidden
  img
    width 100%
  .scene
    position relative
    width 100%
    height 100%
    .img
      position absolute
      top 0
      left 0
      bottom 0
      right 0
      fullBg()
    .img1
      background-image url("./images/02/01.png")
      z-index 3
      animation-duration: 3s
    .img2
      background-image url("./images/02/01文案.png")
      z-index 2
      animation-duration: 8s
    .img3
      background-image url("./images/02/01实景图.jpg")
      z-index 1
      animation-duration: 10s
</style>



// WEBPACK FOOTER //
// src/pages/scene/components/Scene-02.vue